<template>
  <router-view :personalInfo="personalInfo" :homePageInfo="homePageInfo"></router-view>
</template>

<script>
export default {
  props: {
    personalInfo: {
      type: Object
    },
    homePageInfo: {
      type: Object
    }
  }
}
</script>

<style>

</style>
